export default "__VITE_ASSET__BjAGLLrQ__"